import React from 'react';

import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { isMobileSel } from '../../duck/selectors';
import S from '../S';
import styles from './PaginationTotal.less';

interface PaginationTotalProps {
  isMobile: boolean;
  total: number;
  itemsText?: React.ReactNode;
  selected?: number;
  className?: string;
}

const PaginationTotal: React.FC<PaginationTotalProps> = props => {
  const { isMobile, selected, className, itemsText, total } = props;

  const renderItemsText = () => (
    <span className={styles.itemsText}>
      {itemsText || <FormattedMessage id="shared.PaginationTotal.items" />}
    </span>
  );

  const renderTotal = () => (
    <React.Fragment>
      <S size="5" inline className={styles.totalText}>
        <FormattedMessage id="shared.PaginationTotal.total" />
      </S>{' '}
      <S size="5" inline bold>
        {total} {renderItemsText()}
      </S>
      {!isMobile && (
        <S size="5" inline bold className={styles.selectedCount}>
          ({selected} <FormattedMessage id="shared.PaginationTotal.selected" />)
        </S>
      )}
    </React.Fragment>
  );

  const renderSelected = () =>
    isMobile ? (
      <React.Fragment>
        <S size="5" inline bold>
          <FormattedMessage
            id="shared.PaginationTotal.selectedOfTotal"
            values={{
              total,
              selected,
            }}
          />
        </S>{' '}
        <S size="5" inline>
          {renderItemsText()}
          <FormattedMessage id="shared.PaginationTotal.selected" />
        </S>
      </React.Fragment>
    ) : (
      renderTotal()
    );

  const classNames = cn(styles.container, className, {
    [styles.selected]: selected,
  });

  return (
    <div className={classNames}>
      {selected ? renderSelected() : renderTotal()}
    </div>
  );
};

function PaginationTotalContainer(
  props: Omit<PaginationTotalProps, 'isMobile'>,
) {
  const isMobile = useSelector(isMobileSel);

  return <PaginationTotal isMobile={isMobile} {...props} />;
}

export default PaginationTotalContainer;
